import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';
import RoleFilter from './RoleFilter';
import RoleListGroup from './RoleListGroup';
import Spinner from '../UI/Spinner';
import { sortByGroup } from '../../utils/sort-list-util';
import { getRandomList } from '../../utils/random-num-util';
import { filterRoles } from '../../actions/roleActions';
import { add, addAll, remove, reset, sortUpdate, sortUsingSAO } from '../../actions/versionActions';
import versionCountStore from '../../stores/versionCountStore';


import roleStore from '../../stores/rolesStore';
import versionStore from '../../stores/versionStore';

const ButtonsContainer = styled.div`
height: 40px;
display: flex;
flex-direction: row;
gap: 16px;
flex-shrink: 0;
margin-top: 16px;
`;

const ScrollContainer = styled.div`
overflow-y: auto;
position: absolute;
left: 0;
top: 0;
bottom: 0;
right: 20px;
`;

const InnerContainer = styled.div`
display: flex;
flex-direction: column;
width: 100%;
height: 100%;
padding-right: 55px;
padding-left: 40px;
padding-bottom: 20px;
`;

class RoleList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      roleList: this.props.roleList,
      expandedGroupsList: [] // i.e. ['fabled', 'travellers']
    };

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleRoleChange = this.handleRoleChange.bind(this);
    this.handleVersionChange = this.handleVersionChange.bind(this);
    this.handleGroupExpand = this.handleGroupExpand.bind(this);
    this.shuffleRoles = this.shuffleRoles.bind(this);
  }

  UNSAFE_componentWillReceiveProps(props) {
    //Receive updated role list (because of filtering or otherwise).
    if (props.roleList && props.roleList !== this.state.roleList) {
      this.setState({
        isLoading: false,
        roleList: props.roleList
      });
    }
  }

  addRole(role) {
    add(Object.assign(role, { shuffleLock: true }));
    sortUpdate();
  }

  removeRole(role) {
    remove(role);
  }

  sortRoles() {
    sortUsingSAO();
  }

  shuffleRoles() {
    const versionFilter = roleStore.getFilterOptions().versionFilter;
    const filteredRoleList = roleStore.getRoles().filter(role => {
      return (
        role.roleType !== 'travellers'
        && role.roleType !== 'fabled'
        && versionFilter.indexOf(role.version) > -1
      );
    });

    const randomList = getRandomList(
      versionStore.gameCharRestrictions,
      versionStore.getTetherRoles(),
      filteredRoleList,
      this.props.versionList,
      versionCountStore.getCurConfig()
    );

    if (randomList) {
      addAll(randomList);
    }
  }

  //Update role list when text is entered into filter.
  handleFilterChange(e) {
    const filterOptions = {
      nameFilter: e.target.value,
      selectFilter: this.props.filterOptions.selectFilter,
      versionFilter: this.props.filterOptions.versionFilter
    };

    filterRoles(filterOptions);
  }

  // Handle the group expand icon being clicked
  handleGroupExpand(roleListName) {
    let expandedGroupsListCopy = Array.from(this.state.expandedGroupsList);
    let roleListNameIndex =
      this.state.expandedGroupsList.findIndex((item) => item == roleListName);

    if (roleListNameIndex > -1) {
      expandedGroupsListCopy.splice(roleListNameIndex, 1);
    }
    else {
      expandedGroupsListCopy.push(roleListName);
    }

    this.setState({
      expandedGroupsList: expandedGroupsListCopy
    });
  }

  //Update role list when role type is selected.
  handleRoleChange(e) {
    const filterOptions = {
      nameFilter: this.props.filterOptions.nameFilter,
      selectFilter: e.target.value,
      versionFilter: this.props.filterOptions.versionFilter
    };

    filterRoles(filterOptions);
  }

  //Update role list when version type is selected.
  handleVersionChange(e) {
    let versionFilter = this.props.filterOptions.versionFilter.split(',');

    if (!e.target.checked) {
      versionFilter = versionFilter.filter(item => item != e.target.value);
    }
    else if (versionFilter.indexOf(e.target.value) < 0) {
      versionFilter.push(e.target.value);
    }

    const filterOptions = {
      nameFilter: this.props.filterOptions.nameFilter,
      selectFilter: this.props.filterOptions.selectFilter,
      versionFilter: versionFilter.join(',')
    };

    filterRoles(filterOptions);
  }

  render() {
    let displayRoles = [];
    const isMaxed = versionCountStore.getMaxed();
    const cannotRandomise = this.props.isExporting || (isMaxed && !this.props.versionList.find((item) => !item.shuffleLock));
    const cannotSort = this.props.isExporting || versionCountStore.getTotal() < 2;

    if (this.state.isLoading) {
      displayRoles = <div className="rol-list__group role-list__group--loading">
        <Spinner />
      </div>;
    }
    else if (this.state.roleList.length === 0) {
      displayRoles = <div className="role-list__group role-list__group--empty">
        <h4 className="role-list__header">No characters to display!</h4>
      </div>;
    }
    else {
      const roleOrder = ['townsfolk', 'outsider', 'minion', 'demon', 'fabled', 'travellers'];

      const roleListGrouped = sortByGroup(this.state.roleList, 'roleType');

      for (let k in roleOrder) {
        if (roleListGrouped[roleOrder[k]]) {

          // will assume that if the first role of this group is "Extras" version, then the rest
          // are extras
          const roleListName = roleOrder[k];
          const roleList = roleListGrouped[roleListName];
          const isExpandable = roleList.length > 0 && (roleList[0].roleType == 'travellers' || roleList[0].roleType == 'fabled');
          const isExpanded =
            (this.state.expandedGroupsList.findIndex((item) => item == roleListName) > -1) ||
            (isExpandable &&
              !!(this.props.filterOptions.nameFilter || this.props.filterOptions.selectFilter)
            );

          displayRoles.push(
            <RoleListGroup
              key={'role_' + roleListName}
              roleList={roleListGrouped[roleListName]}
              roleListName={roleListName}
              addRole={this.addRole}
              removeRole={this.removeRole}
              listDisabled={isMaxed}
              maxedByType={versionCountStore.getMaxedByType()}
              isExpandable={isExpandable}
              isExpanded={isExpanded}
              handleExpandClick={this.handleGroupExpand}
            />
          )
        }
      }
    }

    return <div className="main__role-list">
      <ScrollContainer>
        <InnerContainer>
          <a href="https://bloodontheclocktower.com"><div className="role-list__logo" /></a>

          <RoleFilter
            handleFilterChange={this.handleFilterChange}
            handleRoleChange={this.handleRoleChange}
            handleVersionChange={this.handleVersionChange}
            versionSet={this.props.versionSet}
            selectedVersions={this.props.filterOptions.versionFilter}
            selectedFilter={this.props.filterOptions.selectFilter}
          />

          <div className="role-list">
            {displayRoles}
          </div>

          <ButtonsContainer>
            <button onClick={() => { reset() }}
              type="button"
              title="Clear script"
              className={classNames(
                "role-list__reset-button",
                { "role-list__reset-button--disabled": this.props.isExporting }
              )}
            >
              Clear
            </button>
            <button onClick={() => { this.shuffleRoles() }}
              disabled={cannotRandomise}
              title="Add random characters"
              type="button"
              className={classNames(
                "role-list__shuffle-button",
                { "role-list__shuffle-button--disabled": cannotRandomise }
              )}
            >
              Randomize
            </button>
            <button onClick={() => { this.sortRoles() }}
              disabled={cannotSort}
              type="button"
              title="Sort using Steven Approved Order"
              className={classNames(
                "role-list__sort-button",
                { "role-list__sort-button--disabled": cannotSort }
              )}
            >
              Sort
            </button>
          </ButtonsContainer>
        </InnerContainer>
      </ScrollContainer>
    </div>
  }
}

RoleList.propTypes = {
  roleList: PropTypes.array,
  isExporting: PropTypes.bool,
  versionList: PropTypes.array,
};

export default RoleList;
